const isProduction = process.env.NODE_ENV === 'production'

// 指定 react-router 的 base，部署到非根目录时需要配置，默认 "/"
const UMI_ROUTER_BASE = !isProduction ? '/' : 'UMI_ROUTER_BASE_PLACEHOLDER__'

// 指定 webpack 的 publicPath，指向静态资源文件所在的路径，默认 ""
const UMI_PUBLIC_PATH = !isProduction ? '' : 'UMI_PUBLIC_PATH_PLACEHOLDER__'

module.exports = {
  UMI_ROUTER_BASE,
  UMI_PUBLIC_PATH
}
